import type { SamlProvider } from "@/api/adminBff";

/**
 * Help text only — SAML is a standard protocol and phase 1 has no backend
 * branching per provider (see SamlIdentityProvider.Provider's own remarks).
 * These hints just point an admin at where each IdP publishes its metadata.
 */
export const PROVIDER_HINTS: Record<SamlProvider, { label: string; metadataUrlHint: string }> = {
    Okta: {
        label: "Okta",
        metadataUrlHint: "https://{yourOktaDomain}/app/{appId}/sso/saml/metadata"
    },
    PingOne: {
        label: "Ping Identity (PingOne)",
        metadataUrlHint: "https://auth.pingone.com/{environmentId}/saml20/metadata/{applicationId}"
    },
    JumpCloud: {
        label: "JumpCloud",
        metadataUrlHint: "IdP metadata URL from the JumpCloud SSO application's SAML tile"
    },
    AzureAd: {
        label: "Azure AD (Microsoft Entra ID)",
        metadataUrlHint:
            "https://login.microsoftonline.com/{tenantId}/federationmetadata/2007-06/federationmetadata.xml?appid={applicationId}"
    },
    Generic: {
        label: "Generic SAML 2.0",
        metadataUrlHint: "https://your-idp.example.com/.../metadata"
    }
};

/** Matches SamlIdentityProvider.EmailClaim's default in the backend — the standard WS-Identity
 * email claim URI most SAML assertions use. */
export const EMAIL_CLAIM_DEFAULT = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress";
